<div class="sec-head">
  <h2>{{ 'Security' | translate }}</h2>
  <p>{{ 'Keep your account protected.' | translate }}</p>
</div>

<button type="button" class="as-card card-btn change-password" (click)="changePassword.emit()">
  <span class="tile"><app-account-icon name="lock" [size]="20"></app-account-icon></span>
  <span class="row-text">
    <b>{{ 'Change password' | translate }}</b>
    <span>{{ 'Update the password you use to sign in.' | translate }}</span>
  </span>
  <app-account-icon class="chevron" name="chevron-right"></app-account-icon>
</button>

<div class="as-card">
  <div class="as-row">
    <div class="tile"><app-account-icon name="shield-check" [size]="20"></app-account-icon></div>
    <div class="row-text">
      <b>{{ 'Two-factor authentication' | translate }}</b>
      <span>{{ 'Require a verification code in addition to your password at sign-in.' | translate }}</span>
    </div>
    <app-account-switch
      class="two-factor-switch"
      [checked]="twoFactorEnabled"
      [disabled]="mfaLocked || twoFactorBusy"
      [label]="'Two-factor authentication' | translate"
      (toggled)="twoFactorToggled.emit()"
    ></app-account-switch>
  </div>
  @if (mfaLocked) {
    <div class="mfa-locked-note">
      {{ 'Your role requires MFA — this setting cannot be disabled.' | translate }}
    </div>
  }
</div>
